/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useReducer, useState } from "react";
import {createFilter} from "react-select";
import SelectAsync from "react-select/async";
import { auth } from "../../utils/auth";
import { apiRequest } from "../../hooks/apiRequest";
import { formatCurrency } from "../../utils/helpers";

const Componente = ({
	index,
    removeComponente,
    producto,
    onChangeComponente,
}) => {
    const [cantidad, setCantidad] = useState(1);
    const [nota, setNota] = useState();
    const [componente, setComponente] = useState(producto);

    const getProductos = async (url) => {
        const table = await apiRequest({}, url, 'get');
        if (table.data) {
            const almacenesGuardados = JSON.parse(localStorage.getItem("almacenes"));
            return table.data.filter((producto) => {
                if (!auth.is('vendedor-cliente')) return true;

                for (let { value } of almacenesGuardados) {
                    if (producto.almacen?.id === value) return true;
                }

                return false;
            }).map(item => {
                return {
                    value: item.id,
                    label: getLabel(item),
                    producto: item
                };
            });
        }
    }

    const onChangeProducto = (e) => {
        setComponente(e.producto);
        onChangeComponente(producto.id, e.producto.costo * cantidad, cantidad, e.producto.cantidad);
    }

    const onChangeCantidad = (e) => {
        setCantidad(e.target.value);
        onChangeComponente(producto.id, componente.costo * e.target.value, e.target.value, componente.cantidad);
    }

    const getLabel = (producto) => {
        return producto.nombre ? `${producto.referencia ? producto.referencia + ' - ' : ''}${producto.nombre} - Stock: ${producto.cantidad}` : '';
    }

	return (
		<div className="precio-item">
			<input
				value={componente.id}
				name={`componentes[${index}][id]`}
				type="hidden"
			/>
			<div className="precio-item__encabezado">
				<span className="precio-item__titulo">Producto {index + 1}</span>
				<button
					type="button"
					className="btn btn-link p-0 text-danger"
					aria-label={`Quitar producto ${index + 1}`}
					onClick={() => removeComponente(producto.id)}
				>
					<i className="fas fa-trash-alt"></i>
				</button>
			</div>
			<div className="form-row">
				<div className="form-group col-12 col-md-6">
					<label className="label form-control-label">
						Producto:
					</label>
					<SelectAsync
						type="text"
						key={`componentes[${index}]`}
						name={`componentes[${index}][componente_id]`}
						placeholder={"Seleccione..."}
						defaultOptions
						loadOptions={(e) => getProductos("productos?limit=50&buscar="+e)}
						filterOption={createFilter({ignoreAccents: false})}
						menuPlacement="auto"
						styles={{
							singleValue: (provided, state) => ({
								...provided,
								width: "100%",
								display: "flex",
							}),
							option: (provided, state) => ({
								...provided,
								backgroundColor: state.isSelected
									? "rgba(152, 204, 245,.3)"
									: "white",
								color: state.isSelected
									? "#008aab"
									: "#666666",
								fontWeight: state.isSelected
									? "600"
									: "normal",
							}),
						}}
						value={componente.id ? {
							value: componente.id,
							label: getLabel(componente)
						} : null}
						onChange={onChangeProducto}

						maxMenuHeight={200}
					/>
				</div>
				<div className="form-group col-6 col-md-2">
					<label className="label form-control-label">
						Cantidad:
					</label>
					<input
						type="number"
						min={0}
						inputMode="decimal"
						className="text-input form-control"
						id={`componentes[${index}][cantidad]`}
						name={`componentes[${index}][cantidad]`}
						value={cantidad}
						onChange={onChangeCantidad}
						step=".01"
					/>
				</div>
				<div className="form-group col-6 col-md-2">
					<label className="label form-control-label">
						Costo:
					</label>
					<input
						readOnly
						type="text"
						value={formatCurrency(componente.costo || 0)}
						className="text-input form-control"
					/>
				</div>
				<div className="form-group col-12 col-md-2">
					<label className="label form-control-label">
						Nota:
					</label>
					<input
						type="text"
						className="text-input form-control"
						id={`componentes[${index}][nota]`}
						name={`componentes[${index}][nota]`}
						value={nota}
						onChange={(e) => setNota(e.target.value) }
					/>
				</div>
			</div>
		</div>
	);
};

export default Componente;
